<template>
  <div class="grid-list-container">
    <div v-for="item in data" class="grid-item-container" :key="item.id" @click="showDetailItem(item)">
      <!-- 电影/剧集：竖向海报卡片 -->
      <div class="movie-card" v-if="item.type === 4 || item.type === 5">
        <div class="poster-cover">
          <img v-lazy="item.cover_url || ''" :key="item.id" class="cover"/>
        </div>
        <div class="card-title">
          {{item.title}}
        </div>
      </div>
      <!-- 普通视频：横版封面卡片 -->
      <div class="video-card" v-if="item.type === 0">
        <div class="video-cover">
          <img v-lazy="item.cover_url" :key="item.id" class="cover"/>
        </div>
        <div class="card-title">
          {{item.title}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {ugcItemTypeMovie, ugcItemTypeSeries} from "../../util/const";

  export default {
    name: "MovieItemListGrid",
    props: {
      data: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      showDetailItem(item) {
        if (item.type === 0) {
          this.$router.push('/video/' + item.id);
        } else if (item.type === ugcItemTypeMovie || item.type === ugcItemTypeSeries) {
          this.$router.push("/movie/" + item.id)
        }
      }
    }
  };
</script>

<style lang="scss" scoped>

  .grid-list-container {
    width: 100%;
    background: white;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .grid-item-container {
    width: 50%;
    padding: 0 2px;
    margin-top: 3px;
  }

  /* 电影/剧集：竖向海报 */
  .poster-cover {
    width: 100%;
    height: 160px;
    overflow: hidden;
    background: #fafafa;
    border-radius: 3px;

    .cover {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      border-radius: 5px;
    }
  }

  /* 普通视频：横版封面 */
  .video-cover {
    width: 100%;
    height: 110px;
    overflow: hidden;
    background: #fafafa;
    position: relative;
    border-radius: 3px;

    .cover {
      width: 100%;
      top: 50%;
      left: 50%;
      display: block;
      position: absolute;
      transform: translate(-50%, -50%);
      border-radius: 5px;
    }
  }

  .card-title {
    color: rgba(34, 34, 34, 0.78);
    margin: 8px 3px;
    font-size: 14px;
    line-height: 1.2;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

</style>
